const teamData = {
    'teams': [
        {
            'name': 'Team 1',
            'img': '/images/team/teams/team1.png',
            'elements': [
                {
                    'name': '/images/team/people/names/name.png',
                    'about': '/images/team/people/captions/caption.png',
                    'img': '/images/team/people/person1.jpg'
                },
                {
                    'name': '/images/team/people/names/name.png',
                    'about': '/images/team/people/captions/caption.png',
                    'img': '/images/team/people/person2.jpg'
                }
            ]
        },
        {
            'name': 'Team 2',
            'img': '/images/team/teams/team2.png',
            'elements': [
                {
                    'name': '/images/team/people/names/name.png',
                    'about': '/images/team/people/captions/caption.png',
                    'img': '/images/team/people/person2.jpg'
                },
                {
                    'name': '/images/team/people/names/name.png',
                    'about': '/images/team/people/captions/caption.png',
                    'img': '/images/team/people/person1.jpg'
                }
            ]
        },
        {
            'name': 'Team 3',
            'img': '/images/team/teams/team3.png',
            'elements': [
                {
                    'name': '/images/team/people/names/name.png',
                    'about': '/images/team/people/captions/caption.png',
                    'img': '/images/team/people/person1.jpg'
                }
            ]
        }
    ]
}

export default teamData